import { connect } from "react-redux";
import moment from "moment";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { checkInterventionAndPlanErrors } from "@/components/Common/GuidedVideoCall/Steps/ProviderWorkflow/InterventionAndPlan/InterventionAndPlanV2/InterventionAndPlanV2FormSchema";
import { GuidedSessionView } from "@/features/notes/(v2)/(guided-session)/GuidedSessionView";
import { PRESCRIBE } from "@/components/Provider/ScheduleAvailability/constants";
import { providerRequests } from "@/api/(requests)/provider";
import { sharedRequests } from "@/api/(requests)/shared";
import { updateNote } from "@/features/notes/(v2)/helpers/update-note";

import { EditNoteWrapper } from "./components/EditNoteWrapper";

class ViewDraftNoteV2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      noteErrors: {},
      noteId: this.props.match.params.noteId,
      patientId: this.props.match.params.patientId,
    };
  }

  componentDidMount = async () => {
    try {
      let urlParams = { patientId: this.state.patientId };
      const searchParams = { note_id: this.state.noteId };
      let note = await sharedRequests.fetch_patient_progress_notes({ searchParams, urlParams });

      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ note });
    } catch (e) {
      console.log(e);
    }
  };

  editHandler = (key, value, nested = true) => {
    this.setState((prevState) => {
      return {
        note: updateNote(prevState.note, nested, key, value),
      };
    });
  };

  signNote = async () => {
    let { note } = this.state;

    note["signature"] = this.props.profile.name;
    note["completed_date_time"] = moment().format();
    await this.setState({ note });
  };

  saveNoteHandler = async (note) => {
    try {
      const urlParams = { patientId: this.state.patientId };

      return providerRequests.put_progress_note({ data: note, urlParams });
    } catch (e) {
      console.log(e);
    }
  };

  noteDraftValidation = () => {
    // runs the validation for intervention and plans
    // because it is the only blocking validator
    const hasInterventionAndPlanError = checkInterventionAndPlanErrors(this.state.note?.content);

    return !hasInterventionAndPlanError;
  };

  noteDraftSubmitHandler = async () => {
    if (!this.noteDraftValidation()) {
      return;
    }
    let note = this.state.note;

    await this.saveNoteHandler(note);
    this.props.history.goBack(-1);
  };

  noteValidation = () => {
    let progressNote = this.state.note;
    const noteErrors = {};

    if (
      !progressNote["ICD_10_axis_1_diagnosis"] ||
      progressNote["ICD_10_axis_1_diagnosis"].length === 0
    ) {
      noteErrors["ICD_10_axis_1_diagnosis"] = "ICD-10 Primary Diagnosis is required";
    }

    if (!progressNote["call_type"]) {
      noteErrors["call_type"] = "CPT Code is required";
    }

    if (this.props.profile.provider_type === PRESCRIBE && !progressNote["service_location"]) {
      noteErrors["service_location"] = "Service Location is required";
    }

    if (checkInterventionAndPlanErrors(progressNote?.content)) {
      // the error message here has no impact, the error is displayed by
      // formik
      noteErrors["goals_objectives_progress_v2"] = "goals_objectives_progress_v2_error";
    }

    this.setState({ noteErrors });

    return Object.keys(noteErrors).length === 0;
  };

  noteSubmitHandler = async () => {
    if (!this.noteValidation()) {
      return;
    }
    await this.signNote();
    let note = this.state.note;

    note["note_state"] = "complete";
    await this.saveNoteHandler(note);
    this.props.history.goBack(-1);
  };

  render() {
    const { note } = this.state;

    if (!note) {
      return <div />;
    }

    return (
      <EditNoteWrapper
        noteDraftSubmitHandler={this.noteDraftSubmitHandler}
        noteSubmitHandler={this.noteSubmitHandler}
        patientId={this.state.patientId}
      >
        <GuidedSessionView
          editable
          editHandler={this.editHandler}
          errors={this.state.noteErrors}
          note={note}
          views={{ createEditView: true, draftView: true }}
        />
      </EditNoteWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
  };
};

export default withRouter(connect(mapStateToProps)(ViewDraftNoteV2));
